import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">焦点专题</h2>
        <p className="section-subtitle">每周精选热门专题，深度解析最受关注的影视话题</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselData.slice(0, 3).map((item) => (
            <article
              key={item.title}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full">
                  {item.badge}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-sm text-primary-600 font-medium">{item.subtitle}</p>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </article>
          ))}

          {carouselData.slice(3, 5).map((item) => (
            <article
              key={item.title}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer md:col-span-2 lg:col-span-3 flex flex-col md:flex-row"
            >
              <div className="relative w-full md:w-2/5 aspect-[16/9] md:aspect-auto overflow-hidden">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full">
                  {item.badge}
                </span>
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <h3 className="text-lg md:text-xl font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-primary-600 font-medium">{item.subtitle}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}